import React, { Component } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { CSVLink } from "react-csv";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import tableRequest from "../../models/tableRequest";
import DemappingReportService from "../../services/DemappingReportService.js";
import DownloadReportService from "../../services/DownloadReportService.js";
import PAService from "../../../src/services/PAService";
import $ from "jquery";
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import productimgpdf from "../../assets/images/PashminaCertificate.pdf";
import productimgUpdatedpdf from "../../assets/images/PashminaUpdatedCertificate.pdf";
import productimg2pdf from "../../assets/images/certificateAdultration.pdf";
import certificateAdultrationUpdated from "../../assets/images/certificateAdultrationUpdated.pdf";
import ".././Pa.css";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import QRCode from "qrcode";
import dowimg from "../../assets/images/dowimg.png";
import dowimgall from "../../assets/images/doll.png";
import { toast, ToastContainer } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

export default class MappingTestReport extends Component {
  constructor(props) {
    super(props);
    this.surveyLink = React.createRef();
    this.DemappingReportService = new DemappingReportService();
    this.DownloadReportService = new DownloadReportService();
    this.PAService = new PAService();
    this.tblResponse = new tableRequest();
    this.state = {
      FromDate: null,
      ToDate: null,
      success: false,
      visible: false,
      sortOrder: "",
      sales: [],
      AllgetData: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      updateLoader: false,
      emptyMessage: "No Data found",
      allData: [],
      uid: "",
      QrData: window.location.href,
      SeqNo: "",
      demapping: [],
      TestPerformed: "",
      UniqueCode: "",
      Weaving: "",
      IsActive: true,
      fakeVerify: false,
      ProductImg: "",
      IsDamaged: true,
      IsDemapped: true,
      ProductCode: "",
      BarCode: "",
      ProductAuthenticationData: null,
      Colour: "",
      Embroidery: "",
      Weight: "",
      Dimensions: "",
      BatchCode: "",
      SupplierCode: "",
      batchCodeOptions: [],
      datasource: [],
    };

    this.onPage = this.onPage.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.GetMappingReportTest = this.GetMappingReportTest.bind(this);
    this.onSort = this.onSort.bind(this);
    this.printpdfDATA = this.PrintpdfDATA.bind(this);
    this.PrintpdfDATAallPdf = this.PrintpdfDATAallPdf.bind(this);
    this.downloadUpdate = this.downloadUpdate.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.reverseGeocodeLatLngAndVerifyProduct =
      this.reverseGeocodeLatLngAndVerifyProduct.bind(this);
  }

  // componentDidMount() {
  //   setTimeout(() => {
  //     var date = new Date();
  //     date.setDate(date.getDate() - 7);
  //     this.tblResponse.FromDate = this.toApiDate(date);
  //     this.tblResponse.ToDate = this.toApiDate(new Date());
  //     this.tblResponse.First = 1;
  //     this.tblResponse.PageSize = this.state.rows;
  //     this.tblResponse.SortColumn = "CreatedDate";
  //     this.tblResponse.SortOrder = "DESC";
  //     this.setState({
  //       FromDate: date,
  //       ToDate: new Date(),
  //     });

  //     this.GetDownload();
  //   }, 1000);
  // }

  componentDidMount() {
    let date = new Date();
    date.setDate(date.getDate() - 7);
    const fromDate = date;
    const toDate = new Date();
    this.tblResponse.FromDate = this.toApiDate(fromDate);
    this.tblResponse.ToDate = this.toApiDate(toDate);
    this.tblResponse.First = 1;
    this.tblResponse.PageSize = this.state.rows;

    this.setState(
      {
        FromDate: fromDate,
        ToDate: toDate,
      },
      () => {
        this.GetDownload();
      },
    );
  }

  toMMDDYYYY(date) {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  toApiDate(date) {
    if (!date) return null;
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return null;
    // Use local date format to prevent timezone shifting
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  GetBatchCodeList() {
    this.DemappingReportService.GetBatchCodeList()
      .then((res) => {
        const responseData = res.data;
        if (
          responseData &&
          responseData.ResponseData &&
          responseData.ResponseData.length > 0
        ) {
          const options = responseData.ResponseData.map((item) => ({
            value: item.BatchCode || item.batchCode,
            label: item.BatchCode || item.batchCode,
          }));
          this.setState({ batchCodeOptions: options });
        }
      })
      .catch((error) => {
        console.error("Error fetching batch codes:", error);
        toast.error("Failed to load batch codes");
      });
  }

  reverseGeocodeLatLngAndVerifyProduct() {
    this.reverseGeoCode(
      this.clsVerifyProduct.Userlatitude,
      this.clsVerifyProduct.Userlongitude,
    ).then(
      (response) => {
        const res = response;
        this.clsVerifyProduct.City = res.address?.state_district;
        this.clsVerifyProduct.State = res.address?.state;
        this.clsVerifyProduct.Country = res.address?.country;
        this.clsVerifyProduct.Pincode = res.address?.postcode;
        this.clsVerifyProduct.Address = res.display_name;
        this.setState({
          Location: res.display_name,
        });
        this.GetVerifyProduct(this.clsVerifyProduct);
      },
      (error) => {
        this.GetVerifyProduct(this.clsVerifyProduct);
      },
    );
  }

  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.tblResponse.BatchCode = null;
    this.GetDownload();
  }

  async GetVerifyProduct(productAuthReq) {
    this.setState({
      IsLocation: false,
    });
    const authData = await this.PAService.VerifyProduct(productAuthReq);
    this.setState({
      ProductAuthenticationData: authData.data.ResponseData,
    });
  }

  // onPage(event) {
  //   this.setState(
  //     {
  //       rows: event.rows,
  //       first: event.first,
  //       loading: true,
  //     },
  //     () => {
  //       this.getLazyLoadingValues(event);
  //       this.GetDownload();
  //     },
  //   );
  // }
  onPage(event) {
    this.setState(
      {
        rows: event.rows,
        first: event.first,
      },
      () => {
        this.applyPagination();
      },
    );
  }

  // GetMappingReportTest() {
  //   this.DemappingReportService.GetMappingReportTest(this.tblResponse).then(
  //     (data) => {
  //       const resdata = data.data;
  //       this.setState({ updateLoader: true });

  //       if (resdata?.ResponseData && resdata.ResponseData.length > 0) {
  //         // resdata.ResponseData.forEach((x) => {
  //         //   x.IsActive = x.hasOwnProperty("IsActive") ? x.IsActive === 1 : true;
  //         //   x.fakeVerify = x.fakeVerify === 1;
  //         // });
  //         resdata.ResponseData.forEach((x) => {
  //           x.IsActive = x.hasOwnProperty("IsActive") ? x.IsActive === 1 : true;
  //           x.fakeVerify = String(x.fakeVerify).toLowerCase() === "true";
  //         });

  //         const filteredData = resdata.ResponseData.filter(
  //           (x) => x.IsActive && !x.fakeVerify,
  //         );

  //         const uniqueBatchCodes = [
  //           ...new Set(filteredData.map((item) => item.BatchCode)),
  //         ];

  //         const batchOptions = uniqueBatchCodes.map((code) => ({
  //           value: code,
  //           label: code,
  //         }));

  //         const selectedBatch = this.state.BatchCode;
  //         const selectedExists = batchOptions.some(
  //           (x) => x.value === selectedBatch,
  //         );

  //         this.setState({
  //           totalRecords: filteredData.length,
  //           first: this.tblResponse.First - 1,
  //           datasource: filteredData,
  //           sales: filteredData.slice(
  //             0,
  //             this.tblResponse.First - 1 + this.tblResponse.PageSize,
  //           ),
  //           batchCodeOptions: batchOptions,
  //           BatchCode: selectedExists ? selectedBatch : "",
  //           loading: false,
  //         });
  //       } else {
  //         this.setState({
  //           totalRecords: 0,
  //           first: 0,
  //           datasource: [],
  //           sales: [],
  //           batchCodeOptions: [],
  //           BatchCode: "",
  //           loading: false,
  //           emptyMessage: resdata?.ResponseMessage || "No Data Found",
  //         });
  //       }
  //     },
  //   );
  // }

  GetMappingReportTest() {
    this.DemappingReportService.GetMappingReportTest(this.tblResponse).then(
      (data) => {
        const resdata = data.data;
        if (
          resdata !== null &&
          resdata.ResponseData !== null &&
          resdata.ResponseData.length > 0
        ) {
          resdata.ResponseData.forEach(function (v) {
            delete v.TotalRows;
            delete v.IsDemapped;
            delete v.ProductImg;
            delete v.FromDate;
            delete v.ToDate;
            delete v.ProductImgBase64;
            delete v.UID;
          });
          if (resdata?.ResponseData?.length > 0) {
            const filteredData = resdata.ResponseData.filter(
              (x) => String(x.fakeVerify).toLowerCase() === "false",
            );
            this.setState({
              allData: filteredData,
            });
            this.setState({ allData: filteredData }, () => {
              this.surveyLink.link.click();
            });
          }
        }
      },
    );
  }
  handleChange(event) {
    const { name, value } = event.target;

    if (name === "BatchCode") {
      this.setState({ BatchCode: value, loading: true }, () => {
        this.tblResponse.BatchCode = value || null;
        this.tblResponse.SearchValue = "";

        this.tblResponse.FromDate = this.toApiDate(this.state.FromDate);
        this.tblResponse.ToDate = this.toApiDate(this.state.ToDate);

        this.tblResponse.First = 1;
        this.tblResponse.PageSize = this.state.rows;
        this.tblResponse.SortColumn = "CreatedDate";
        this.tblResponse.SortOrder = "DESC";
        this.setState({ first: 0 }, this.GetDownload);
      });
      return;
    }

    this.setState({ [name]: value });
  }

  FilterData() {
    const { FromDate, ToDate } = this.state;

    if (!FromDate || !ToDate) {
      toast.error("Please select both From and To dates.");
      return;
    }

    if (FromDate.getTime() > ToDate.getTime()) {
      toast.error("From Date cannot be after To Date.");
      return;
    }

    this.setState({ loading: true, first: 0 });

    // this.tblResponse.FromDate = this.toMMDDYYYY(FromDate);
    this.tblResponse.FromDate = this.toApiDate(this.state.FromDate);
    this.tblResponse.ToDate = this.toApiDate(this.state.ToDate);
    // this.tblResponse.ToDate = this.toMMDDYYYY(ToDate);
    this.tblResponse.First = 1;
    this.tblResponse.PageSize = this.state.rows;
    this.tblResponse.SortColumn = "CreatedDate";
    this.tblResponse.SortOrder = "DESC";
    this.tblResponse.BatchCode = this.state.BatchCode || null;

    this.GetDownload();
  }

  getLazyLoadingValues(event) {
    this.tblResponse.PageSize = event.rows;
    const currentPage = Math.floor(event.first / event.rows) + 1;

    this.tblResponse.First = currentPage;
    this.tblResponse.PageNo = currentPage;

    this.tblResponse.SearchValue = event.globalFilterValue || "";

    this.tblResponse.SortColumn = event.sortField || "CreatedDate";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";

    if (this.state.FromDate) {
      this.tblResponse.FromDate = this.toApiDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      this.tblResponse.ToDate = this.toApiDate(this.state.ToDate);
    }

    this.setState({ rows: event.rows, first: event.first });
  }

  // GetDownload() {
  //   this.setState({ loading: true });

  //   this.tblResponse.SortColumn = this.tblResponse.SortColumn || "CreatedDate";
  //   this.tblResponse.SortOrder = this.tblResponse.SortOrder || "DESC";
  //   this.tblResponse.First = this.tblResponse.First || 1;
  //   this.tblResponse.PageSize = this.tblResponse.PageSize || this.state.rows;
  //   this.tblResponse.FromDate = this.toApiDate(this.state.FromDate);
  //   this.tblResponse.ToDate = this.toApiDate(this.state.ToDate);
  //   this.tblResponse.BatchCode = this.state.BatchCode || null;

  //   this.DemappingReportService.GetMappingReportTest(this.tblResponse)
  //     .then((data) => {
  //       const resdata = data.data;

  //       if (resdata?.ResponseData?.length > 0) {
  //         // const formattedData = resdata.ResponseData.map((x) => ({
  //         //   ...x,
  //         //   IsActive: x.hasOwnProperty("IsActive") ? x.IsActive === 1 : true,
  //         //   fakeVerify:
  //         //     x.fakeVerify === "False"
  //         // })).filter((x) => x.IsActive && !x.fakeVerify);
  //         const formattedData = resdata.ResponseData.map((x) => ({
  //           ...x,
  //           IsActive: x.hasOwnProperty("IsActive") ? x.IsActive === 1 : true,
  //         })).filter(
  //           (x) => x.IsActive && String(x.fakeVerify).toLowerCase() === "false",
  //         );

  //         const filtered = resdata.ResponseData.filter(
  //           (x) => String(x.fakeVerify).toLowerCase() === "false",
  //         );
  //         const uniqueBatchCodes = [
  //           ...new Set(
  //             filtered
  //               .map((item) => item.BatchCode)
  //               .filter((code) => code && code.trim() !== ""),
  //           ),
  //         ];

  //         const batchOptions = uniqueBatchCodes.map((code) => ({
  //           value: code,
  //           label: code,
  //         }));

  //         const selectedBatch = this.state.BatchCode;
  //         const selectedExists = batchOptions.some(
  //           (x) => x.value === selectedBatch,
  //         );

  //         // this.setState({
  //         //   datasource: formattedData,
  //         //   sales: formattedData,
  //         //   totalRecords:
  //         //     resdata.TotalRecords ||
  //         //     (resdata.ResponseData[0] && resdata.ResponseData[0].TotalRows) ||
  //         //     formattedData.length,
  //         //   first: this.tblResponse.First - 1,
  //         //   batchCodeOptions: batchOptions,
  //         //   BatchCode: selectedExists ? selectedBatch : "",
  //         //   loading: false,
  //         // });
  //         this.setState({
  //           datasource: resdata.ResponseData,
  //           sales: resdata.ResponseData, // SP se limited data hi aayega
  //           totalRecords: resdata.ResponseData[0]?.TotalRows || 0,
  //           loading: false,
  //         });
  //       } else {
  //         this.setState({
  //           datasource: [],
  //           sales: [],
  //           totalRecords: 0,
  //           first: 0,
  //           batchCodeOptions: [],
  //           BatchCode: "",
  //           loading: false,
  //         });
  //       }
  //     })
  //     .catch(() => {
  //       this.setState({
  //         datasource: [],
  //         sales: [],
  //         totalRecords: 0,
  //         first: 0,
  //         batchCodeOptions: [],
  //         BatchCode: "",
  //         loading: false,
  //       });
  //     });
  // }

  applyPagination() {
    const { datasource, first, rows } = this.state;

    const paginatedData = datasource.slice(first, first + rows);

    this.setState({
      sales: paginatedData,
    });
  }
  GetDownload() {
    this.setState({ loading: true });

    this.tblResponse.FromDate = this.toApiDate(this.state.FromDate);
    this.tblResponse.ToDate = this.toApiDate(this.state.ToDate);
    this.tblResponse.BatchCode = this.state.BatchCode || null;
    this.tblResponse.PageSize = -1;
    this.tblResponse.PageNo = 1;

    this.DemappingReportService.GetMappingReportTest(this.tblResponse).then(
      (data) => {
        const resdata = data.data;

        if (resdata?.ResponseData?.length > 0) {
          const filteredData = resdata.ResponseData.filter(
            (x) => String(x.fakeVerify).toLowerCase() === "false",
          );
          // this.setState(
          //   {
          //     datasource: filteredData,
          //     totalRecords: filteredData.length,
          //     loading: false,
          //   },
          //   () => {
          //     this.applyPagination();
          //   },
          // );
          const uniqueBatchCodes = [
            ...new Set(
              filteredData
                .map((item) => item.BatchCode)
                .filter((code) => code && String(code).trim() !== "")
                .map((code) => String(code).trim()),
            ),
          ];

          const batchOptions = uniqueBatchCodes.map((code) => ({
            value: code,
            label: code,
          }));

          const selectedBatch = this.state.BatchCode;
          const selectedExists = batchOptions.some(
            (x) => x.value === selectedBatch,
          );

          this.setState(
            {
              datasource: filteredData,
              totalRecords: filteredData.length,
              batchCodeOptions: batchOptions,
              BatchCode: selectedExists ? selectedBatch : "",
              loading: false,
            },
            () => {
              this.applyPagination();
            },
          );
        } else {
          this.setState({
            datasource: [],
            sales: [],
            totalRecords: 0,
            loading: false,
          });
        }
      },
    );
  }

  onSort(event) {
    const sortField = event.sortField || "CreatedDate";
    const sortOrder = event.sortOrder === 1 ? "ASC" : "DESC";

    this.tblResponse.SortColumn = sortField;
    this.tblResponse.SortOrder = sortOrder;
    this.tblResponse.First = 1;

    if (!event.sortField && !event.sortOrder) {
      this.tblResponse.SortColumn = "CreatedDate";
      this.tblResponse.SortOrder = "DESC";
    }

    this.GetDownload();
  }

  downloadUpdate(data) {
    const formData = {
      SeqNo: data,
    };
    this.DownloadReportService.CreateDownloadCount(formData).then((data) => {
      const resdata = data.data;

      if (resdata.ResponseMessage == "success") {
        // toast.success("success");
      }
    });
  }

  getDate(d) {
    var date = d.split("/");
    var f = new Date(date[2], parseInt(date[1]) - 1, date[0]);
    return f;
  }

  PrintpdfDATA = async (rowData) => {
    let QRDATA = window.location.origin + "/pa?uid=" + rowData.UID;
    let qrdata = await this.genQR(QRDATA);

    if (!qrdata) {
      console.error("QR code generation failed, aborting print.");
      return;
    }
    var imageURL = rowData.ProductImg;
    rowData.ProductImgBase64 = await this.getBase64FromUrl(imageURL);

    console.log("fakeVerify value:", rowData.fakeVerify);
    console.log("fakeVerify type:", typeof rowData.fakeVerify);

    if (rowData.fakeVerify === "True" || rowData.fakeVerify === true) {
      console.log("Using Non-Genuine certificate path");
      if (this.getDate(rowData.CreatedDate) >= new Date("08/27/1900")) {
        await this.printUpdatedFakeDocument(rowData, qrdata);
      } else {
        await this.printDocumentfakeVerify(rowData, qrdata);
      }
    } else {
      console.log("Using Genuine certificate path");
      if (this.getDate(rowData.CreatedDate) >= new Date("08/27/1900")) {
        await this.printUpdatedDocument(rowData, qrdata);
      } else {
        await this.printDocument(rowData, qrdata);
      }
    }
  };

  // Helper function to detect image format from base64 data
  detectImageFormat = (base64Data, filename) => {
    // First try to detect from data URL prefix (most reliable)
    if (base64Data && base64Data.includes(",")) {
      const dataUrlPrefix = base64Data.split(",")[0];
      if (dataUrlPrefix.includes("png")) return "png";
      if (dataUrlPrefix.includes("jpeg") || dataUrlPrefix.includes("jpg"))
        return "jpeg";
    }

    // Fallback to file extension detection
    if (filename) {
      const ext = filename.toLowerCase().split(".").pop();
      if (ext === "png") return "png";
      if (ext === "jpg" || ext === "jpeg") return "jpeg";
    }

    // Default to jpeg
    return "jpeg";
  };

  getBase64FromUrl = async (url) => {
    if (!url) throw new Error("URL is undefined");
    try {
      // Use proxy to avoid CORS issues
      const proxyUrl = url.replace("https://localhost:44340", "");
      const response = await fetch(proxyUrl);
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();

      // Get actual MIME type from blob for accurate format detection
      const mimeType = blob.type;
      const actualFormat = mimeType.split("/")[1]; // 'jpeg', 'png', etc.

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const result = reader.result;
          // Store the actual format info for later use
          if (result && result.includes("base64")) {
            // Add format metadata to the result for proper detection later
            resolve(result);
          } else {
            reject(new Error("Failed to convert to base64"));
          }
        };
        reader.onerror = reject;
      });
    } catch (err) {
      if (
        err.message.includes("CORS") ||
        err.message.includes("Failed to fetch")
      ) {
        console.error(
          "CORS Error: Unable to fetch image from different origin. Please configure CORS on the server or use a proxy.",
        );
        toast.error(
          "Unable to load product image due to CORS restrictions. PDF will be generated without the image.",
        );
      } else if (err.message.includes("PNG") || err.message.includes("SOI")) {
        console.error(
          "Image format error: The file format is not valid or corrupted.",
          err,
        );
        toast.error(
          "Product image format is not supported or corrupted. PDF will be generated without the image.",
        );
      } else {
        console.error("Failed to fetch or convert to base64:", err);
        toast.error(
          "Failed to load product image. PDF will be generated without the image.",
        );
      }
      return null;
    }
  };

  PrintpdfDATAallPdf() {
    confirmAlert({
      title: "Confirmation",
      message: "Are you sure you want to Download All.",
      buttons: [
        {
          label: "Yes",
          onClick: () =>
            this.DemappingReportService.GetMappingReportTest(
              this.tblResponse,
            ).then((data) => {
              const resdata = data.data;
              if (
                resdata !== null &&
                resdata.ResponseData !== null &&
                resdata.ResponseData.length > 0
              ) {
                let data = resdata.ResponseData;
                (async () => {
                  const onlyGenuine = resdata.ResponseData.filter(
                    (x) => x.fakeVerify === "False",
                  );
                  for (const obj of onlyGenuine) {
                    await this.PrintpdfDATA(obj);
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                  }
                })();
              }
            }),
        },
        {
          label: "No",
        },
      ],
    });
  }

  actionTemplate(rowData) {
    const submit = () => {
      confirmAlert({
        title: "Confirmation",
        message: "Are you sure you want to Download.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.PrintpdfDATA(rowData),
          },
          {
            label: "No",
          },
        ],
      });
    };

    return (
      <span className="dowimg">
        <img
          onClick={submit}
          type="button"
          src={dowimg}
          width="45"
          height="47"
        />
      </span>
    );
  }

  // --------------------------------------------------------------
  //   All PDF printing functions remain UNCHANGED below this line
  // --------------------------------------------------------------

  async printDocument(rowData, qrdata) {
    const url = productimgUpdatedpdf;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    // QR IMAGE
    const qrImage = await pdfDoc.embedPng(qrdata.split("base64,")[1]);
    const qrDims = qrImage.scale(0.5);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // =========================
    // TEXT DATA
    // =========================

    // Product Code
    firstPage.drawText(`${rowData.ProductCode}-${rowData.BarCode}`, {
      x: 125,
      y: 316.5,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Tests Performed
    firstPage.drawText(rowData.TestPerformed ?? "", {
      x: 152,
      y: 218.3,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Colour
    firstPage.drawText(rowData.Colour ?? "", {
      x: 175,
      y: 285,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Weaving
    firstPage.drawText(rowData.Weaving ?? "", {
      x: 98,
      y: 253.1,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Embroidery
    firstPage.drawText(rowData.Embroidery ?? "", {
      x: 473,
      y: 253.3,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Date
    firstPage.drawText(rowData.CreatedDate ?? "", {
      x: 482,
      y: 350,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Batch/Supplier
    firstPage.drawText(`${rowData.BatchCode}/${rowData.SupplierCode}`, {
      x: 154,
      y: 350,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Weight
    firstPage.drawText(rowData.Weight ?? "", {
      x: 448,
      y: 316.5,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Dimensions
    firstPage.drawText(rowData.Dimensions ?? "", {
      x: 467,
      y: 285.1,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // =========================
    // QR IMAGE
    // =========================

    firstPage.drawImage(qrImage, {
      x: 815,
      y: 118,
      width: qrDims.width,
      height: qrDims.height,
    });

    // =========================
    // PRODUCT IMAGE
    // =========================

    if (rowData.ProductImgBase64) {
      const base64Data = rowData.ProductImgBase64.split("base64,")[1];
      let productImage;

      try {
        const format = this.detectImageFormat(
          rowData.ProductImgBase64,
          rowData.ProductImg,
        );

        if (format === "png") {
          productImage = await pdfDoc.embedPng(base64Data);
        } else {
          productImage = await pdfDoc.embedJpg(base64Data);
        }

        const prodDims = productImage.scale(1.13);

        firstPage.drawImage(productImage, {
          x: 642,
          y: 206,
          width: 274,
          height: 160,
        });
      } catch (err) {
        console.error("Failed to embed product image:", err);
      }
    }

    // =========================
    // SAVE PDF
    // =========================

    const pdfBytes = await pdfDoc.save();
    const url1 = window.URL.createObjectURL(new Blob([pdfBytes]));
    const link = document.createElement("a");
    link.href = url1;
    const supdata = rowData.SupplierCode;
    link.setAttribute("download", supdata + ".pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  async printUpdatedDocument(rowData, qrdata) {
    const url = productimgUpdatedpdf;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const jpgImage = await pdfDoc.embedPng(qrdata.split("base64,")[1]);
    const jpgDims = jpgImage.scale(0.5);

    const jpgImage2 = await pdfDoc.embedPng(qrdata.split("base64,")[1]);
    const jpgDimsProdImg = jpgImage2.scale(1.13);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    firstPage.drawText(rowData.ProductCode + "-" + rowData.BarCode, {
      x: 125,
      y: 316.5,
      size: 11,
      font: helveticaFont,
      size: 12,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(rowData.TestPerformed ?? "", {
      x: 152,
      y: 218.3,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(
      rowData.Colour == null || rowData.Colour == undefined
        ? ""
        : rowData.Colour,
      {
        x: 175,
        y: 285,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Weaving == null || rowData.Weaving == undefined
        ? ""
        : rowData.Weaving,
      {
        x: 98,
        y: 253.1,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Embroidery == null || rowData.Embroidery == undefined
        ? ""
        : rowData.Embroidery,
      {
        x: 473,
        y: 253.3,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.CreatedDate == null || rowData.CreatedDate == undefined
        ? ""
        : rowData.CreatedDate,
      {
        x: 482,
        y: 350,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(rowData.BatchCode + "/" + rowData.SupplierCode, {
      x: 154,
      y: 350,
      size: 11,
      font: helveticaFont,
      size: 12,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(
      rowData.Weight == null || rowData.Weight == undefined
        ? ""
        : rowData.Weight,
      {
        x: 448,
        y: 316.5,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Dimensions == null || rowData.Dimensions == undefined
        ? ""
        : rowData.Dimensions,
      {
        x: 467,
        y: 285.1,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawImage(await pdfDoc.embedPng(qrdata.split("base64,")[1]), {
      x: 815,
      y: 118,
      width: jpgDims.width,
      height: jpgDims.height,
      size: 11,
      font: helveticaFont,
      size: 15,
      color: rgb(0, 0, 0),
    });

    async function embedProductImage(pdfDoc, base64, filename) {
      if (!base64) return null;

      // Use robust format detection
      const format = this.detectImageFormat(base64, filename);

      try {
        if (format === "png") {
          return await pdfDoc.embedPng(base64.split("base64,")[1] || base64);
        } else {
          return await pdfDoc.embedJpg(base64.split("base64,")[1] || base64);
        }
      } catch (e) {
        console.error("Image embed failed:", e);
        return null;
      }
    }

    const prodImage = await embedProductImage(
      pdfDoc,
      rowData.ProductImgBase64,
      rowData.ProductImg,
    );

    if (prodImage) {
      firstPage.drawImage(prodImage, {
        x: 690,
        y: 214,
        width: jpgDimsProdImg.width,
        height: jpgDimsProdImg.height,
      });
    }

    const pdfBytes = await pdfDoc.save();
    const url1 = window.URL.createObjectURL(new Blob([pdfBytes]));
    const link = document.createElement("a");
    link.href = url1;
    const supdata = rowData.SupplierCode;
    link.setAttribute("download", supdata + ".pdf");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async printUpdatedFakeDocument(rowData, qrdata) {
    const url = certificateAdultrationUpdated;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const jpgImage = await pdfDoc.embedPng(qrdata.split("base64,")[1]);
    const jpgDims = jpgImage.scale(0.5);

    const jpgImage2 = await pdfDoc.embedPng(qrdata.split("base64,")[1]);
    const jpgDimsProdImg = jpgImage2.scale(1.2);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    firstPage.drawText(rowData.ProductCode + "-" + rowData.BarCode, {
      x: 125.5,
      y: 337.6,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(
      rowData.TestPerformed == null || rowData.TestPerformed == undefined
        ? ""
        : rowData.TestPerformed,
      {
        x: 152,
        y: 224.4,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Colour == null || rowData.Colour == undefined
        ? ""
        : rowData.Colour,
      {
        x: 175,
        y: 301.1,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Weaving == null || rowData.Weaving == undefined
        ? ""
        : rowData.Weaving,
      {
        x: 97,
        y: 264,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Embroidery == null || rowData.Embroidery == undefined
        ? ""
        : rowData.Embroidery,
      {
        x: 493,
        y: 263.9,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.CreatedDate == null || rowData.CreatedDate == undefined
        ? ""
        : rowData.CreatedDate,
      {
        x: 502,
        y: 372.9,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(rowData.BatchCode + "/" + rowData.SupplierCode, {
      x: 154.5,
      y: 373,
      size: 11,
      font: helveticaFont,
      size: 12,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(
      rowData.Weight == null || rowData.Weight == undefined
        ? ""
        : rowData.Weight,
      {
        x: 468,
        y: 337.8,
        size: 11,
        font: helveticaFont,
        size: 12,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(rowData.Dimensions ?? "", {
      x: 487,
      y: 301.4,
      size: 12,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawImage(await pdfDoc.embedPng(qrdata.split("base64,")[1]), {
      x: 825,
      y: 120,
      width: jpgDims.width,
      height: jpgDims.height,
      size: 11,
      font: helveticaFont,
      size: 15,
      color: rgb(0, 0, 0),
    });

    const pdfBytes = await pdfDoc.save();
    const url1 = window.URL.createObjectURL(new Blob([pdfBytes]));
    const link = document.createElement("a");
    link.href = url1;
    const supdata = rowData.SupplierCode;
    link.setAttribute("download", supdata + ".pdf");

    document.body.appendChild(link);
    link.click();
  }

  async printDocumentfakeVerify(rowData, qrdata) {
    const url = productimg2pdf;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const jpgImage = await pdfDoc.embedPng(qrdata.split("base64,")[1]);
    const jpgDims = jpgImage.scale(0.5);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    firstPage.drawText(rowData.ProductCode + "-" + rowData.BarCode, {
      x: 126,
      y: 334,
      size: 11,
      font: helveticaFont,
      size: 13,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(rowData.TestPerformed ?? "", {
      x: 140,
      y: 225,
      size: 11,
      font: helveticaFont,
      size: 13,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(
      rowData.Colour == null || rowData.Colour == undefined
        ? ""
        : rowData.Colour,
      {
        x: 89,
        y: 307,
        size: 11,
        font: helveticaFont,
        size: 13,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Weaving == null || rowData.Weaving == undefined
        ? ""
        : rowData.Weaving,
      {
        x: 100,
        y: 279,
        size: 11,
        font: helveticaFont,
        size: 13,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Embroidery == null || rowData.Embroidery == undefined
        ? ""
        : rowData.Embroidery,
      {
        x: 115,
        y: 252,
        size: 11,
        font: helveticaFont,
        size: 13,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.CreatedDate == null || rowData.CreatedDate == undefined
        ? ""
        : rowData.CreatedDate,
      {
        x: 690,
        y: 362.5,
        size: 11,
        font: helveticaFont,
        size: 13,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(rowData.BatchCode + "/" + rowData.SupplierCode, {
      x: 155.5,
      y: 365,
      size: 11,
      font: helveticaFont,
      size: 12,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(
      rowData.Weight == null || rowData.Weight == undefined
        ? ""
        : rowData.Weight,
      {
        x: 642,
        y: 225,
        size: 11,
        font: helveticaFont,
        size: 13,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawText(
      rowData.Dimensions == null || rowData.Dimensions == undefined
        ? ""
        : rowData.Dimensions,
      {
        x: 816,
        y: 225,
        size: 11,
        font: helveticaFont,
        size: 13,
        color: rgb(0, 0, 0),
      },
    );

    firstPage.drawImage(await pdfDoc.embedPng(qrdata.split("base64,")[1]), {
      x: 800,
      y: 118,
      width: jpgDims.width,
      height: jpgDims.height,
      size: 11,
      font: helveticaFont,
      size: 13,
      color: rgb(0, 0, 0),
    });

    if (rowData.ProductImgBase64) {
      const base64Data = rowData.ProductImgBase64.split("base64,")[1];
      let productImage;

      try {
        // Use robust format detection
        const format = this.detectImageFormat(
          rowData.ProductImgBase64,
          rowData.ProductImg,
        );

        if (format === "png") {
          productImage = await pdfDoc.embedPng(base64Data);
        } else {
          productImage = await pdfDoc.embedJpg(base64Data);
        }
        const productDims = productImage.scale(0.5);

        firstPage.drawImage(productImage, {
          x: 450,
          y: 237,
          width: 318,
          height: 100,
        });
      } catch (err) {
        console.error("Failed to embed product image:", err);
        // Continue without image
      }
    }

    const pdfBytes = await pdfDoc.save();
    const url1 = window.URL.createObjectURL(new Blob([pdfBytes]));
    const link = document.createElement("a");
    link.href = url1;
    const supdata = rowData.SupplierCode;
    link.setAttribute("download", supdata + ".pdf");

    document.body.appendChild(link);
    link.click();
  }

  genQR = async (data) => {
    try {
      const base64 = await QRCode.toDataURL(data);
      return base64;
    } catch (err) {
      console.error("QR generation failed:", err);
      return null;
    }
  };

  formatDate = (row) => {
    if (!row.CreatedDate) return "";

    const d = new Date(row.CreatedDate);

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();

    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
  };

  render() {
    const items = [{ label: "Masters" }, { label: "Mapping-Test Report" }];
    const home = { icon: "pi pi-home", url: "/dashboard" };

    let header = (
      <div className="row">
        <div className="col-md-8">
          <form className="form-inline">
            <div className="form-group mr-2">
              <Calendar
                value={this.state.FromDate}
                name="FromDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="From Date"
              />
            </div>
            <div className="form-group">
              <Calendar
                value={this.state.ToDate}
                name="ToDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="To Date"
              />
            </div>
            <button
              type="button"
              onClick={this.FilterData}
              className="btn btn-primary ml-3"
            >
              Submit
            </button>
            <div className="form-group mr-3">
              {" "}
              <span> </span>
            </div>
            <div className="form-group mr-2" style={{ minWidth: "200px" }}>
              <Dropdown
                value={this.state.BatchCode}
                options={this.state.batchCodeOptions}
                onChange={(e) =>
                  this.handleChange({
                    target: { name: "BatchCode", value: e.value },
                  })
                }
                optionLabel="label"
                optionValue="value"
                placeholder="Search Batch"
                filter
                showClear
                className="w-100"
                style={{ height: "38px" }}
              />
            </div>

            <span>
              <img
                onClick={this.PrintpdfDATAallPdf}
                src={dowimgall}
                width={140}
                height={45}
              />
            </span>
          </form>
        </div>
        <div className="text-right col-md-4">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText
            type="search"
            onInput={this.searchFilter}
            placeholder="Global Search"
            size="22"
          />
          <button
            className="btn btn-primary ml-2 mb-1 export-disabled"
            target="_blank"
            onClick={this.GetMappingReportTest}
          >
            Export
          </button>

          <CSVLink
            hidden={true}
            data={this.state.allData}
            ref={(r) => (this.surveyLink = r)}
            filename={"MappingTest report.csv"}
          >
            Export
          </CSVLink>
        </div>
      </div>
    );

    return (
      <>
        <Card className="mt5">
          <div className="row">
            <div className="col-md-6 heading report">
              <h3>Mapping-Test Report </h3>
            </div>
            <div className="col-md-6 custom-breadcrumb report">
              <BreadCrumb model={items} home={home} />
            </div>
          </div>
          <DataTable
            exportFilename="GetMappingTest Report"
            scrollable
            responsive={true}
            header={header}
            globalFilter={this.state.globalFilter}
            emptyMessage={this.state.emptyMessage}
            value={this.state.sales}
            sortMode="multiple"
            paginator={true}
            rows={this.state.rows}
            rowsPerPageOptions={[5, 100, 200, this.state.totalRecords]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column field="SeqNo" header="Seq No" sortable={true} />
            <Column field="ProductCode" header="Product" sortable={true} />
            <Column field="BarCode" header="Bar Code" sortable={true} />
            <Column field="UniqueCode" header="Unique Code" sortable={true} />
            <Column field="BatchCode" header="Batch Code" sortable={true} />
            <Column
              field="SupplierCode"
              header="Supplier Code"
              sortable={true}
            />
            <Column field="Colour" header="Colour" sortable={true} />
            <Column field="Weaving" header="Weaving" sortable={true} />
            <Column field="Embroidery" header="Embroidery" sortable={true} />

            <Column field="Weight" header="Weight" sortable={true} />
            <Column field="Dimensions" header="Dimensions" sortable={true} />
            <Column
              field="TestPerformed"
              header="Tests Performed"
              sortable={true}
            />
            <Column
              field="CreatedDate"
              header="Created Date"
              sortable={true}
              body={this.formatDate}
            />

            <Column body={this.actionTemplate} header="Certificate Download" />
          </DataTable>
        </Card>
      </>
    );
  }
}
